<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link :to="tramiteRoute">Trámites</router-link> >
            <router-link :to="tramiteFormRoute">Trámite {{ this.p_idTramite }}</router-link> >
            <router-link :to="`/autorizacion-tramite/${p_idTramite}`">Solicitudes para modificación y carga de archivos</router-link> >
            Autorización {{ p_idAutorizacion }}
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp">
      <AyudaTramiteForm />
    </Modal>

    <hr />

    <!-- Modal de Tramite -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="row">
          <!-- Columna izquierda -->
          <div class="col-9">
            <div class="row">
              <div class="col-2">
                <label for="idTramite" class="form-label fw-bold"
                  >&nbsp;&nbsp;ID Trámite</label
                >
              </div>
              <div class="col-4">
                <span id="idTramite">{{ datoTramite.idTramite }}</span>
              </div>
                <div class="col-3">
                  <label for="idAutorizacion" class="form-label fw-bold"
                  >&nbsp;&nbsp;ID Autorización</label
                  >
                </div>
                <div class="col-3">
                  <span id="idAutorizacion">{{ datoAutorizacion.idAutorizacion }}</span>
                </div>
            </div>
          </div>

          <!-- Columna derecha -->
          <div class="col-3 text-end">
            <button
              class="btn btn-outline-secondary d-inline-flex align-items-center gap-1"
              @click.prevent="mostrarOcultarBloque"
              style="
                padding-top: 0.1rem;
                padding-bottom: 0.1rem;
                padding-left: 0.5rem;
                padding-right: 0.5rem;
              "
            >
              <span class="material-icons" style="font-size: 1.1rem">
                {{
                  mostrarBloque ? "remove_circle_outline" : "add_circle_outline"
                }}
              </span>
              {{ mostrarBloque ? "Más información" : "Menos información" }}
            </button>
          </div>
        </div>
        <div v-if="mostrarBloque" class="mb-3">
          <form>
            <div class="modal-body">

              <!-- Selección de Servicio -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="idServicio" class="form-label">Servicio</label>
                  </div>
                  <div class="col-3">
                    <input
                      type="text"
                      class="form-control"
                      id="servicioNombre"
                      name="servicioNombre"
                      v-model="datoTramite.servicioNombre"
                      disabled
                    />
                  </div>
                  <div class="col-2">
                    <label for="fechaDesde" class="form-label"
                      >Fecha desde</label
                    >
                  </div>
                  <div class="col-2">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaDesde"
                      name="fechaDesde"
                      :disabled="
                        this.datoTramite.estadoTramite !== 'REGISTRADO'
                      "
                      :value="getFormattedDate(datoTramite.fechaDesde)"
                      required
                    />
                  </div>
                  <div class="col-2">
                    <label for="fechaHasta" class="form-label"
                      >Fecha hasta</label
                    >
                  </div>
                  <div class="col-2">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaHasta"
                      name="fechaHasta"
                      :disabled="
                        this.datoTramite.estadoTramite !== 'REGISTRADO'
                      "
                      :value="getFormattedDate(datoTramite.fechaHasta)"
                      required
                    />
                  </div>
                </div>
              </div>

              <!-- Descripción -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="descripcion" class="form-label"
                      >Descripción</label
                    >
                  </div>
                  <div class="col-11">
                    <textarea
                      class="form-control"
                      id="descripcion"
                      name="descripcion"
                      v-model="datoTramite.descripcion"
                      style="text-transform: uppercase"
                      :disabled="
                        this.datoTramite.estadoTramite !== 'REGISTRADO'
                      "
                    >
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <hr>
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="descripcion" class="form-label"
                    >Descripción</label
                  >
                </div>
                <div class="col-5">
                  <textarea
                    class="form-control"
                    id="descripcion"
                    name="descripcion"
                    v-model="datoAutorizacion.descripcion"
                    disabled
                  ></textarea>
                </div>
                <div class="col-1">
                  <label for="observacion" class="form-label"
                    >Observación</label
                  >
                </div>
                <div class="col-5">
                  <textarea
                    class="form-control"
                    id="observacion"
                    name="observacion"
                    v-model="datoAutorizacion.observacion"
                    disabled
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="estadoAut" class="form-label">Estado Autorización</label>
                </div>
                <div class="col-2">
                  <input
                    type="text"
                    class="form-control"
                    id="estadoAut"
                    name="estadoAut"
                    v-model="datoAutorizacion.estadoAut"
                    disabled
                  />
                </div>
                <div class="col-2">
                  <label for="fechaReg" class="form-label"
                    >Fecha de registro</label
                  >
                </div>
                <div class="col-2">
                  <input
                    type="text"
                    class="form-control"
                    id="fechaReg"
                    name="fechaReg"
                    :value="getFormattedDate(datoAutorizacion.fechaReg)"
                    disabled
                  />
                </div>
                <div class="col-2">
                  <label for="fechaApr" class="form-label">Fecha Aprobación</label>
                </div>
                <div class="col-2">
                  <input
                    type="text"
                    class="form-control"
                    id="fechaApr"
                    name="fechaApr"
                    :value="getFormattedDate(datoAutorizacion.fechaApr)"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
        </div>
      </div>
    </div>

    <!-- Estructura de Tabs -->
    <div class="tabs">
      <button
        class="tablink"
        @click="showTable = 'cargaDatos'"
        :class="{ 'active-tab': showTable === 'cargaDatos' }"
      >
        Carga de Datos
      </button>

      <button
        v-if="paso3"
        class="tablink"
        @click="showTable = 'planilla'"
        :class="{ 'active-tab': showTable === 'planilla' }"
      >
        Atenciones Médicas
      </button>

      <button
        v-if="paso4"
        class="tablink"
        @click="showTable = 'sinArchivos'"
        :class="{ 'active-tab': showTable === 'sinArchivos' }"
      >
        Atenciones médicas sin documentación cargada
      </button>
    </div>

    <!-- Contenido dinámico según la pestaña seleccionada -->

    <div v-if="showTable === 'cargaDatos'">
      <CargaMes
        :p_idTramite="p_idTramite"
		:p_idAutorizacion="p_idAutorizacion"
        :p_numSemana="datoTramite.numSemana"
        :p_maxSemana="datoTramite.maxSemanas"
        :p_fechaDesde="datoTramite.fechaDesde"
        @estadoTramite="handleEstadoTramite"
        @actualizarTramite="handleActualizarTramite"
      >
      </CargaMes>
    </div>

    <div v-if="showTable === 'planilla'">
      <Planilla :p_tramite="datoTramite"></Planilla>
    </div>

    <div v-if="showTable === 'sinArchivos'">
      <TramitesPlaSinArchivos
        :p_idtramite="p_idTramite"
      ></TramitesPlaSinArchivos>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import CargaMes from "../forms/CargaMes.vue";
import Planilla from "../forms/Planilla.vue";
import TramitesPlaSinArchivos from "../reportes/TramitesPlaSinArchivos.vue";

//import { format } from 'date-fns';

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    Footer,
    CargaMes,
    Planilla,
    TramitesPlaSinArchivos,
  },
  data() {
    return {
      tramites: [],
      datoTramite: {},
      datoAutorizacion: {},
      nombreBusqueda: "",
      titulo: "",
      modalWindow: true,  
      p_idTramite: 0,
      p_idAutorizacion: 0,
      p_idUsuario: 0,
      idPerfil: 0,
      showTable: "cargas", // Pestaña por defecto
      servicios: [],
      mostrarBloque: false,
      archivoDatos: null, // Archivo CSV seleccionado
      archivosPlanillas: [], // Arreglo para múltiples archivos
      paginaActual: 1, // Definir paginaActual si se usa
      message: "", // Mensaje de éxito o error
      messageClass: "", // Clase de Bootstrap para el mensaje
      filteredPlantillas: [], // Lista filtrada según la búsqueda
      searchText: "", // Texto de búsqueda
      selectedPlantilla: null, // Plantilla seleccionada
      loading: false,
      mensaje: "",
      success: false,
      numeroCargas: 0,
    };
  },
  computed: {
    paso2() {
      return (
        this.datoTramite.estadoTramite === "CARGADO" ||
        this.datoTramite.estadoTramite === "ESTRUCTURADO" ||
        this.datoTramite.estadoTramite === "DOCUMENTADO" ||
        this.datoTramite.estadoTramite === "ENVIADO" ||
        this.numeroCargas > 1
      );
    },
    paso3() {
      return (
        this.datoTramite.estadoTramite === "ESTRUCTURADO" ||
        this.datoTramite.estadoTramite === "DOCUMENTADO" ||
        this.datoTramite.estadoTramite === "ENVIADO" ||
        this.numeroCargas > 1
      );
    },
    paso4() {
      return (
        this.datoTramite.estadoTramite === "ESTRUCTURADO" ||
        this.datoTramite.estadoTramite === "DOCUMENTADO" ||
        this.datoTramite.estadoTramite === "ENVIADO" ||
        this.numeroCargas > 1
      );
    },
    botonAutorizaciones() {
      return (
        this.datoTramite.estadoTramite === "RECIBIDO" ||
        this.datoTramite.estadoTramite === "EN PROCESO" ||
        this.datoTramite.estadoTramite === "OBSERVACIONES" ||
        this.numeroCargas > 1
      );
    },
    tramiteRoute() {
      if (this.idPerfil == 15) return "/tramite-carga";
      if (this.idPerfil == 16) return "/tramite";
      return "/"; // Ruta predeterminada
    },
    tramiteFormRoute() {
      if (this.idPerfil == 15) return "/tramiteform-carga/" + this.p_idTramite;
      if (this.idPerfil == 16) return "/tramiteform/" + this.p_idTramite;
      return "/"; // Ruta predeterminada
    },
  },
  mounted() {
    this.p_idTramite = this.$route.params.p_idtramite;
    this.p_idAutorizacion = this.$route.params.p_idautorizacion;
    this.p_idUsuario = window.sessionStorage.getItem("idUsuario");
    this.idPerfil = window.sessionStorage.getItem("idPerfil");
    this.getDataTramite();
    this.getDataAutorizacion();
    this.fetchCount();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
    handleEstadoTramite(value) {
      this.datoTramite.estadoTramite = value;
    },
    handleActualizarTramite(value) {
      if (value) {
        this.getDataTramite();
        this.getDataAutorizacion();
      }
    },
    async getDataTramite() {
      await api.get(`/vwtramites/${this.p_idTramite}`)
        .then((response) => {
          this.datoTramite = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener datos del trámite:", error);
        });
    },
    getDataAutorizacion() {
      api.get("/vwautorizacions/" +
            this.p_idAutorizacion
        )
        .then((response) => {
          this.datoAutorizacion = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener datos de la persona:", error);
        });
    },
    async fetchCount() {
      try {
        const response = await api.get("/vwcargas/count/" + this.p_idTramite
        );
        this.numeroCargas = response.data;
      } catch (error) {
        console.error("Error al obtener el conteo:", error);
      }
    },
    validarForm() {
      const requiredFields = [
        "idPrestador",
        "idServicio",
        "fechaDesde",
        "fechaHasta",
        "descripcion",
      ];
      const requiredFieldsText = [
        "idPrestador",
        "idServicio",
        "fechaDesde",
        "fechaHasta",
        "descripcion",
      ];
      return validarForm(this.datoTramite, requiredFields, requiredFieldsText);
    },
    async actualizarSemana() {
      if (this.validarForm() === 1) {
        this.datoTramite.numSemana = this.datoTramite.numSemana + 1;
        try {
          await api.post("/tramites/" +
              window.sessionStorage.getItem("idUsuario"),
            this.datoTramite
          );
          Swal.fire(
            "Correcto!",
            "Ya puedes cargar la segunda semana!",
            "success"
          );
        } catch (error) {
          Swal.fire("Error!", "Inténtelo de nuevo!", "error");
        }
      }
    },
  },
};
</script>

<style src="@/assets/css/tabs.css" scoped></style>
<style scoped>
.upload-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
  margin: 10px auto;
  padding: 15px;
  border: 2px solid #ccc;
  border-radius: 12px;
  background-color: #f7f9fc;
}

.row.align-items-center {
  display: flex;
  align-items: center;
}

.text-end {
  text-align: right;
}
</style>

<style scoped>
.input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}
</style>

<style scoped>
.btn {
  font-size: 16px;
  padding: 10px 20px;
}

.alert {
  margin-top: 20px;
  padding: 10px;
  border-radius: 5px;
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>
<style>
.centrado {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100h; /* Usa viewport height para ocupar toda la pantalla */
}
</style>
